import React, { useState, useRef, useEffect } from 'react';
import './CreatePostModal.css';

const CreatePostModal = ({ isOpen, onClose, onSubmit }) => {
  const [title, setTitle] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const editorRef = useRef(null);
  const imageUploadRef = useRef(null);
  
  // 初始化
  useEffect(() => {
    if (isOpen && editorRef.current) {
      editorRef.current.focus();
    }
  }, [isOpen]);

  // 如果模态框不打开，不渲染任何内容
  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!title || !editorRef.current?.innerHTML || !selectedSection) {
      alert('请填写完整信息！');
      return;
    }
    
    // 提交时获取最新的编辑器内容
    const currentContent = editorRef.current.innerHTML;
    
    onSubmit({ title, content: currentContent, section: selectedSection });
    setTitle('');
    if (editorRef.current) {
      editorRef.current.innerHTML = '';
    }
    setSelectedSection('');
    onClose();
  };

  // 处理图片上传
  const handleImageUpload = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.click();
    }
  };

  // 插入图片到编辑器
  const insertImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (editorRef.current) {
          editorRef.current.focus();
          document.execCommand('insertImage', false, event.target.result);
          
          // 确保图片样式正确
          const imgs = editorRef.current.querySelectorAll('img');
          if (imgs.length > 0) {
            const lastImg = imgs[imgs.length - 1];
            lastImg.style.maxWidth = '100%';
            lastImg.style.height = 'auto';
            lastImg.style.margin = '10px 0';
          }
        }
      };
      reader.readAsDataURL(file);
      // 清空文件输入，允许再次选择同一文件
      e.target.value = '';
    }
  };

  const sections = [
    { id: 'hot', name: '热门活动' },
    { id: 'mentor', name: '工作室收徒' },
    { id: 'qa', name: '你问我答' },
    { id: 'share', name: '分享海龟汤' },
    { id: 'birthday', name: '生日祝福' }
  ];

  return (
    <div className="modal-overlay">
      <div className="create-post-modal">
        <div className="modal-header">
          <h2>发帖</h2>
          <button className="close-button" onClick={onClose}></button>
        </div>
        
        <div className="modal-body">
          <div className="title-input-container">
            <input 
              type="text" 
              placeholder="帖子标题" 
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="post-title-input"
            />
          </div>
          
          <div className="editor-container">
            <div className="editor-toolbar">
              <button 
                className="toolbar-button image-button"
                onClick={handleImageUpload}
                type="button"
                title="上传图片"
              >
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"/>
                </svg>
                上传图片
              </button>
              <input 
                type="file" 
                ref={imageUploadRef}
                onChange={insertImage}
                accept="image/*"
                style={{ display: 'none' }}
              />
            </div>
            
            <div
              ref={editorRef}
              className="richtext-editor"
              contentEditable="true"
              suppressContentEditableWarning={true}
              placeholder="请输入帖子内容..."
              onFocus={() => {
                // 确保编辑器有可见的光标
                if (editorRef.current && editorRef.current.innerHTML.trim() === '') {
                  editorRef.current.innerHTML = '';
                }
              }}
              onBlur={() => {
                // 确保编辑器内容不为空
                if (editorRef.current && editorRef.current.innerHTML.trim() === '') {
                  editorRef.current.innerHTML = '';
                }
              }}
            />
          </div>
          
          <div className="section-selection">
            <p className="section-title">请选择发帖分区</p>
            <div className="section-buttons">
              {sections.map(section => (
                <button 
                  key={section.id} 
                  className={`section-button ${selectedSection === section.id ? 'active' : ''}`}
                  onClick={() => setSelectedSection(section.id)}
                >
                  {section.name}
                </button>
              ))}
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="publish-button" onClick={handleSubmit}>发布帖子到 论坛</button>
        </div>
      </div>
    </div>
  );
};

export default CreatePostModal; 